import router from '@/router'

export function redirect(url, param = {}) {
   let flag = (JSON.stringify(param) == "{}");
   if (!flag) {
      router.push({ path: url, query: param })
   } else {
      router.push(url)
   }
}

export function setCache(name, val) {
   if (typeof val == 'object') {
      val = JSON.stringify(val)
   }
   localStorage.setItem(name, val)
}

export function getCache(name) {
   var data = localStorage.getItem(name)
   if (data != null) {
      if (data.indexOf('[') != -1 || data.indexOf('[{') != -1 || data.indexOf('{') != -1) {
         return JSON.parse(data)
      } else {
         return data
      }
   }

}

export function delCache(name) {
   localStorage.removeItem(name)
}
//全选
export function checkedAll(data, checkedAll) {
   var selected = []
   if (checkedAll) {
      data.forEach(item => {
         selected.push(item.id)
      })
   } else {
      selected = []
   }

   return selected

}
/*
     * 参数说明：
     * number：要格式化的数字
     * decimals：保留几位小数
     * dec_point：小数点符号
     * thousands_sep：千分位符号
     * */
export function number_format(number, decimals, dec_point, thousands_sep) {

   number = (number + '').replace(/[^0-9+-Ee.]/g, '');
   var n = !isFinite(+number) ? 0 : +number,
      prec = !isFinite(+decimals) ? 2 : Math.abs(decimals),
      sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
      dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
      s = '',
      toFixedFix = function (n, prec) {
         var k = Math.pow(10, prec);
         return '' + Math.ceil(n * k) / k;
      };

   s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
   var re = /(-?\d+)(\d{3})/;
   while (re.test(s[0])) {
      s[0] = s[0].replace(re, "$1" + sep + "$2");
   }

   if ((s[1] || '').length < prec) {
      s[1] = s[1] || '';
      s[1] += new Array(prec - s[1].length + 1).join('0');
   }
   return s.join(dec);
}

// 对Date的扩展，将 Date 转化为指定格式的String   
// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，   
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)   
// 例子：   
// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423   
// (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18   
export function dateFormat(fmt, date) {
   let ret;
   let opt = {
       "Y+": date.getFullYear().toString(),        // 年
       "m+": (date.getMonth() + 1).toString(),     // 月
       "d+": date.getDate().toString(),            // 日
       "H+": date.getHours().toString(),           // 时
       "M+": date.getMinutes().toString(),         // 分
       "S+": date.getSeconds().toString()          // 秒
       // 有其他格式化字符需求可以继续添加，必须转化成字符串
   };
   for (let k in opt) {
       ret = new RegExp("(" + k + ")").exec(fmt);
       if (ret) {
           fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
       };
   };
   return fmt;
}